import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AutoTab from '../components/AutoTab';
import CheltuieliTab from '../components/CheltuieliTab';
import CarburantTab from '../components/CarburantTab';
import PieseTab from '../components/PieseTab';
import ReviziiTab from '../components/ReviziiTab';
import PersonalTab from '../components/PersonalTab';
import DocumenteTransportTab from '../components/DocumenteTransportTab';
import CursaGpsTab from '../components/CursaGpsTab';
import DashboardAlerts from '../components/Dashboard';
import Rapoarte from './Rapoarte';
import Admin from './Admin';
import Cont from './Cont';
import { ToastContainer } from '../components/Toast';
import PWAInstall from '../components/PWAInstall';
import Footer from '../components/Footer';
import api from '../services/api';

const TABS = [
  { id:'alerts',     label:'🏠', fullLabel:'Acasă' },
  { id:'auto',       label:'🚛', fullLabel:'Autovehicule' },
  { id:'cheltuieli', label:'📄', fullLabel:'Cheltuieli' },
  { id:'carburant',  label:'⛽', fullLabel:'Carburant' },
  { id:'piese',      label:'🔧', fullLabel:'Piese' },
  { id:'revizii',    label:'🔩', fullLabel:'Revizii' },
  { id:'personal',   label:'🧑‍✈️', fullLabel:'Personal' },
  { id:'documente-transport', label:'📦', fullLabel:'Documente de Transport' },
  { id:'cursa-gps',  label:'📍', fullLabel:'Cursă GPS' },
  { id:'rapoarte',   label:'📊', fullLabel:'Rapoarte' },
];

export default function Dashboard() {
  const [tab, setTab] = useState('alerts');
  const [menuOpen, setMenuOpen] = useState(false);
  // v68: cand soferul apasa "Du-mă la foaie" in avertismentul de dupa Stop-ul unei curse
  // GPS, comutam pe tab-ul Documente de Transport si ii spunem ce foaie sa deschida direct
  // in editare - vezi CursaGpsTab (onNavigateToFoaie) si DocumenteTransportTab (openFoaieId).
  const [openFoaieId, setOpenFoaieId] = useState(null);
  const navigate = useNavigate();
  const username = localStorage.getItem('username') || '';
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const rol = localStorage.getItem('rol') || 'Level_0';
  const isDriver = rol === 'conducator_auto';
  const vehiculAsignat = localStorage.getItem('vehiculAsignat') || '';

  const logout = () => {
    // Best-effort - revoca token-ul (si refresh-token-ul) pe server (logout real), dar
    // nu blocam delogarea locala daca serverul nu raspunde.
    const refreshToken = localStorage.getItem('refreshToken');
    api.post('/api/auth/logout', { refreshToken }).catch(()=>{});
    // Stergem DOAR datele sesiunii, nu tot localStorage - altfel se pierde si
    // "tine minte utilizatorul", care trebuie sa supravietuiasca peste logout.
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('isDemo');
    localStorage.removeItem('rol');
    localStorage.removeItem('vehiculAsignat');
    navigate('/login');
  };

  const allTabs = isAdmin ? [...TABS, { id:'admin', label:'⚙️', fullLabel:'Admin' }] : TABS;

  // Alte tab-uri (ex. Autovehicule, cand limita e atinsa) pot cere navigarea directa
  // spre pagina Admin - de obicei spre sub-tab-ul "Limită cont" (vezi sessionStorage
  // "adminInitialTab", citit de Admin.js la montare).
  useEffect(() => {
    const handler = () => { if (isAdmin) setTab('admin'); };
    window.addEventListener('navigateAdmin', handler);
    return () => window.removeEventListener('navigateAdmin', handler);
  }, [isAdmin]);

  const currentTab = tab === 'cont'
    ? { label:'👤', fullLabel:'Contul meu' }
    : allTabs.find(t => t.id === tab);

  return (
    <div>
      <ToastContainer />
      <nav className="navbar">
        <span className="navbar-title">🚛 Monitorizare Flotă</span>

        {/* Desktop menu */}
        <div className="nav-desktop">
          {allTabs.map(t => (
            <button key={t.id}
              className={`nav-btn ${tab===t.id?'active':''}`}
              onClick={() => setTab(t.id)}>
              {t.label} {t.fullLabel}
            </button>
          ))}
        </div>

        <div className="nav-right">
          <PWAInstall />
          <button className={`nav-btn ${tab==='cont'?'active':''}`}
            onClick={() => setTab('cont')}
            title="Contul meu"
            style={{fontWeight:'bold'}}>
            👤 {username}
          </button>
          <button className="nav-btn" onClick={logout} title="Ieșire">⏻</button>
          {/* Hamburger pentru mobile */}
          <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="nav-mobile-menu">
          {allTabs.map(t => (
            <button key={t.id}
              className={`nav-mobile-btn ${tab===t.id?'active':''}`}
              onClick={() => { setTab(t.id); setMenuOpen(false); }}>
              {t.label} {t.fullLabel}
            </button>
          ))}
          <button className="nav-mobile-btn"
            onClick={() => { setTab('cont'); setMenuOpen(false); }}>
            👤 Contul meu
          </button>
          <button className="nav-mobile-btn" onClick={logout}>⏻ Ieșire</button>
        </div>
      )}

      <div className="main-content">
        {tab === 'alerts' ? (
          <div className="card">
            <div className="card-header">🏠 Acasă — Alerte și expirări</div>
            <div className="card-body" style={{padding:16}}>
              <DashboardAlerts />
            </div>
          </div>
        ) : (
          <div className="card">
            <div className="card-header">
              {currentTab?.label} {currentTab?.fullLabel}
            </div>
            <div className="card-body">
              {tab==='auto'       && <AutoTab />}
              {tab==='cheltuieli' && <CheltuieliTab />}
              {tab==='carburant'  && <CarburantTab />}
              {tab==='piese'      && <PieseTab />}
              {tab==='revizii'    && <ReviziiTab />}
              {tab==='personal'   && <PersonalTab />}
              {tab==='documente-transport' && <DocumenteTransportTab openFoaieId={openFoaieId} onOpenedFoaie={()=>setOpenFoaieId(null)} />}
              {tab==='cursa-gps' && <CursaGpsTab onNavigateToFoaie={(id)=>{ setOpenFoaieId(id); setTab('documente-transport'); }} />}
              {tab==='rapoarte'   && <Rapoarte />}
              {tab==='admin'      && <Admin />}
              {tab==='cont'       && <Cont />}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
